import { css } from "@emotion/css";

import { grey, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createTaskItemStyles = ({
  borderRadius,
  typography,
  palette,
  boxShadows,
  spacing,
}: Theme) => {
  return {
    root: css({
      display: "grid",
      gridTemplateColumns: "50px 1fr 37px",
      minHeight: 90,
      textDecoration: "none",
      backgroundColor: grey[100],
      borderRadius: borderRadius.medium,
      fontWeight: typography.fontWeight.medium,
      marginBottom: spacing(1),
    }),
    progress: css({
      display: "grid",
      placeItems: "center",
      color: grey[500],
      backgroundColor: palette.secondary.light,
      borderRadius: borderRadius.medium,
    }),
    taskDone: css({
      color: white,
      backgroundColor: palette.primary.light,
      boxShadow: boxShadows.taskDone,
    }),
    content: css({
      display: "grid",
      gap: spacing([1.5, 0]),
      padding: spacing([2, 0, 0, 2]),
    }),
    name: css({
      fontSize: typography.fontSize.large,
      paddingBottom: spacing(0.5),
    }),
    additionalInfo: css({
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
    }),
    arrowWrapper: css({
      display: "grid",
      placeItems: "center",
    }),
    tick: css({
      transform: "translateY(1px)",
      pointerEvents: "none",
    }),
    ratingWrapper: css({
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      margin: spacing([0, 1, 0.5, 0]),
    }),
    points: css({
      margin: spacing([0.5, 1.5, 0.5, 0]),
    }),
    groupWrapper: css({
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      marginBottom: spacing(1),
    }),
    avatar: css({
      marginTop: spacing(1),
    }),
    group: css({
      margin: spacing([0.5, 0, 0, 0.5]),
    }),
  };
};
